import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import { ConsistencyChecksIcon } from '..';
import { h } from 'vue';
import FormToggle from '@frontend/components/FormToggle';

export function CheckQuality() {
    return SettingsEntry(
        'Check edge and surface quality',

        '',

        img(ConsistencyChecksIcon, 'Check edge and surface quality'),

        h(FormToggle, {
            value: app.state.always_run_consistency_checks_on_rest,
            'onUpdate:value': x => app.state.always_run_consistency_checks_on_rest = x,
        }),
    );
}
